export default {
  apiKey: "AIzaSyCBT5FTCCoQSGZz3ZMeUY36T3KRHlTWgdc",
  authDomain: "web-app-pia.firebaseapp.com",
  databaseURL: "https://web-app-pia-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "web-app-pia",
  storageBucket: "web-app-pia.appspot.com",
  messagingSenderId: "795588350906",
  appId: "1:795588350906:web:d80f9d5146c4642ca60383"
};
